export default {"src":"/_next/static/media/expand-button-down.796b34be.svg","height":6,"width":10,"blurWidth":0,"blurHeight":0};